var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 0.333313C3.31992 0.333313 0.333252 3.31998 0.333252 6.99998C0.333252 10.68 3.31992 13.6666 6.99992 13.6666H10.3333V12.3333H6.99992C4.10659 12.3333 1.66659 9.89331 1.66659 6.99998C1.66659 4.10665 4.10659 1.66665 6.99992 1.66665C9.89325 1.66665 12.3333 4.10665 12.3333 6.99998V7.95331C12.3333 8.47998 11.8599 8.99998 11.3333 8.99998C10.8066 8.99998 10.3333 8.47998 10.3333 7.95331V6.99998C10.3333 5.15998 8.83992 3.66665 6.99992 3.66665C5.15992 3.66665 3.66659 5.15998 3.66659 6.99998C3.66659 8.83998 5.15992 10.3333 6.99992 10.3333C7.91992 10.3333 8.75992 9.95998 9.35992 9.35331C9.79325 9.94665 10.5399 10.3333 11.3333 10.3333C12.6466 10.3333 13.6666 9.26665 13.6666 7.95331V6.99998C13.6666 3.31998 10.6799 0.333313 6.99992 0.333313ZM6.99992 8.99998C5.89325 8.99998 4.99992 8.10665 4.99992 6.99998C4.99992 5.89331 5.89325 4.99998 6.99992 4.99998C8.10659 4.99998 8.99992 5.89331 8.99992 6.99998C8.99992 8.10665 8.10659 8.99998 6.99992 8.99998Z",
    fill: "#0050AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmail);
export default __webpack_public_path__ + "static/media/amail.4357df90.svg";
export { ForwardRef as ReactComponent };